/**
 * Vue-js directive for focusing an element.
 * @example <input type="text" v-focus />
 */
export const focus = {
  mounted: (el, { value }) => {
    if (typeof value === 'undefined' || value === true) {
      el.focus();
    }
  },
};
